export class SetVariableActionSettings {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
